// VVS // Translations (EN / FR / NL / DE)
// Credit: Victor Suciu
// Human, natural translations // underground Brussels energy

const T = {
  EN: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Where sound becomes space.',
      line1: 'A flow. A vision. A sound.',
      line2: 'We don\'t follow currents.',
      line3: 'We create waves.',
      enter: 'Enter',
      listen: 'Listen',
    },
    listen: {
      title: 'Start here.',
      sub1: 'Deep grooves.',
      sub2: 'Slow pressure.',
      sub3: 'Controlled release.',
    },
    portals: {
      title: 'A universe you can feel.',
      desc: '',
      vision: 'Vision', vision_desc: 'The philosophy behind the waves.',
      artists: 'Artists', artists_desc: 'The collective. The signals.',
      events: 'Events', events_desc: 'The next memory. The space.',
    },
    featured: {
      caption: 'Featured Artist',
      tagline: 'Founder. Sound as architecture.',
      bio: 'Between hard-groove structures and dub atmospheres, fromnow creates spaces that hold you.',
      open: 'Open Profile',
    },
    events_teaser: {
      caption: 'Next memory.',
      view: 'View Full Event →',
    },
    contact_section: {
      title: 'Open a conversation.',
      desc: 'Demos, partnerships, or a simple message.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'A portal is opening.',
      link: 'Visit fairflow.be →',
    },
    events: {
      caption: 'Next Memory',
      subline: '2 rooms.\nNo headliners.\nOne vision.',
      date_lbl: 'Date',
      venue_lbl: 'Venue',
      ticket_lbl: 'Ticketing',
      view_lineup: 'View lineup',
      hide_lineup: 'Hide lineup',
      get_tickets: 'Get Tickets',
      lineup_title: 'Full Line-up // 24 Artists',
      last: 'Last Event',
      upcoming: 'Upcoming Events',
      upcoming_empty: 'New announcements coming soon.',
      upcoming_follow: 'Follow @vaguevisionsound for updates.',
    },
    contact: {
      caption: 'Open a Conversation',
      title: 'Contact',
      desc: 'You\'re a musician.\nYou want to collaborate.\nYou have a project looking for a home.',
      name: 'Your name',
      email: 'Your email',
      subject: 'What\'s this about',
      message: 'Your message',
      demo_link: 'Private link (SoundCloud, Drive, Dropbox)',
      demo_ph: 'SoundCloud private link / Drive / Dropbox URL',
      demo_hint: 'Please avoid expiring links.',
      send: 'Send',
      sent_to: 'Sent to:',
      success_title: 'Message Received',
      success_at: 'We\'ll be in touch at',
      success_close: 'Everything flows.',
      type_general: 'General Contact',
      type_partnerships: 'Partnerships',
      type_demo: 'Send a Demo',
      back_to_contact: 'Back to contact',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'A flow.',
      intro2: 'A vision.',
      intro3: 'A sound.',
      intro4: 'We don\'t follow currents.',
      intro5: 'We create waves.',
      behind_label: 'Behind the label',
      behind_title: 'BUILDING SOMETHING REAL IN A SYSTEM THAT WASN\'T MADE FOR ARTISTS',
      manifesto_title: 'More than a label.',
      manifesto_p1: 'Vague Vision Sound is more than a label, a brand or an agency.',
      manifesto_p2: 'It is a space for artists who dare to elevate beyond limits, explore every facet of their identity, and leave a mark on culture.',
      manifesto_p3: 'We empower creators through innovation and collaboration. From production to performance, we design immersive experiences that resonate with something deeper.',
      what_we_do: 'What we do',
      releases_title: 'Releases',
      releases_desc: 'The music we release is chosen for its depth, its concept, its lasting impact. Not for the algorithm. Every release is a universe // built with intention, released with care.',
      events_title: 'Events',
      events_desc: 'From underground basements to the Brussels Planetarium, we produce immersive experiences that push the limits of what a night can be. Sound, visuals, space // treated as one single medium.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'We support artists across the full spectrum // production, mix & mastering, booking, visual identity, communication. We don\'t just release music. We build careers.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Professional audio services for artists with a real sonic signature. All genres. Handled by fromnow from his own setup and via Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'We didn\'t just talk about transparency // we built it. FairFlow is a contribution and transparency infrastructure co-created by fromnow and developer Julien, designed for artists, labels and cultural collectives. Because the underground deserves better tools.',
      quote_fromnow: '"Creating was never optional. It was about survival. VVS is the structure I wish I\'d had when I started // built so no artist ever has to choose between their vision and the world."',
      wave_meaning: 'Vague means motion.\nA force in constant evolution.\nShaping everything in its path.\n\nJust like sound.\nJust like vision.\nJust like those who create without fear.',
      wave_poetry: 'A wave is never still.\nIt rises from unseen forces.\nEnergy. Gravity. Momentum.\n\nNo wave is ever the same.\nYet each carries the pulse of its origin.\n\nSome crash with intensity.\nSome stretch endlessly across the horizon.\nSome are born from chaos. Others flow with precision.\n\nBut all exist to move. To transform. To redefine space.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Some experiences are not meant to be watched.',
      beyond_text2: 'They are meant to surround you.',
      beyond_text3: 'Under the dome, sound becomes architecture.\nLight becomes movement.\nPresence becomes tangible.',
      within_title: 'WITHIN',
      within_desc: '360° Immersive Show',
      within_venue: 'Planetarium // Royal Observatory of Belgium',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Get tickets',
      closing1: 'This is not just about sound.',
      closing2: 'It is about impact.',
      closing3: 'It is about connection.',
      closing4: 'Step into your flow.',
      closing5: 'Own your wave.',
      moodboard: 'View Moodboard on Pinterest',
      discover: 'Discover',
    },
    artists: {
      caption: 'The Collective',
      title: 'Artists',
      desc: 'Each artist in the VVS collective is a signal. A frequency with its own architecture.',
      open: 'Open',
      incoming: 'Incoming',
      more_soon: 'More artists soon',
      rvre_note: 'RVRE is the next artist to be signed.',
      open_profile: 'Open Full Profile →',
      coming_soon: 'Full profile // coming soon',
      back_to_artists: 'Back to Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'A portal is opening.',
      coming: 'Visit fairflow.be',
      back: 'Back to VVS',
      interest: 'Open fairflow.be',
      project: 'A Vague Vision Sound project',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. All rights reserved.',
    },
    buttons: {
      discover: 'Discover',
      listen: 'Listen',
      view_gallery: 'View Gallery',
      back_to_artists: 'Back to Artists',
      send: 'Send',
    },
  },

  FR: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Là où le son devient espace.',
      line1: 'Un flow. Une vision. Un son.',
      line2: 'On ne suit pas les courants.',
      line3: 'On crée des vagues.',
      enter: 'Entrer',
      listen: 'Écouter',
    },
    listen: {
      title: 'Commence ici.',
      sub1: 'Grooves profonds.',
      sub2: 'Pression lente.',
      sub3: 'Libération contrôlée.',
    },
    portals: {
      title: 'Un univers qu\'on ressent.',
      desc: '',
      vision: 'Vision', vision_desc: 'La philosophie derrière les vagues.',
      artists: 'Artists', artists_desc: 'Le collectif. Les signaux.',
      events: 'Events', events_desc: 'Le prochain souvenir. L\'espace.',
    },
    featured: {
      caption: 'Artiste à l\'honneur',
      tagline: 'Fondateur. Le son comme architecture.',
      bio: 'Entre structures hard-groove et atmosphères dub, fromnow crée des espaces qui te tiennent.',
      open: 'Voir le profil',
    },
    events_teaser: {
      caption: 'Prochain souvenir.',
      view: 'Voir l\'event complet →',
    },
    contact_section: {
      title: 'Ouvre une conversation.',
      desc: 'Démos, partenariats, ou juste un message.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Un portail s\'ouvre.',
      link: 'Visiter fairflow.be →',
    },
    events: {
      caption: 'Prochain Souvenir',
      subline: '2 salles.\nPas de têtes d\'affiche.\nUne vision.',
      date_lbl: 'Date',
      venue_lbl: 'Lieu',
      ticket_lbl: 'Billetterie',
      view_lineup: 'Voir le lineup',
      hide_lineup: 'Masquer le lineup',
      get_tickets: 'Billets',
      lineup_title: 'Line-up complet // 24 Artists',
      last: 'Dernier Event',
      upcoming: 'Prochains Events',
      upcoming_empty: 'Nouvelles annonces bientôt.',
      upcoming_follow: 'Suis @vaguevisionsound pour les updates.',
    },
    contact: {
      caption: 'Ouvre une Conversation',
      title: 'Contact',
      desc: 'T\'es musicien.\nT\'as envie de collaborer.\nT\'as un projet qui cherche une maison.',
      name: 'Ton nom',
      email: 'Ton email',
      subject: 'De quoi il s\'agit',
      message: 'Ton message',
      demo_link: 'Lien privé (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Lien privé SoundCloud / Drive / Dropbox',
      demo_hint: 'Évite les liens qui expirent.',
      send: 'Envoyer',
      sent_to: 'Envoyé à :',
      success_title: 'Message reçu',
      success_at: 'On te recontacte à',
      success_close: 'Tout coule.',
      type_general: 'Contact général',
      type_partnerships: 'Partenariats',
      type_demo: 'Envoyer une démo',
      back_to_contact: 'Retour au contact',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Un flow.',
      intro2: 'Une vision.',
      intro3: 'Un son.',
      intro4: 'On ne suit pas les courants.',
      intro5: 'On crée des vagues.',
      behind_label: 'Behind the label',
      behind_title: 'CONSTRUIRE QUELQUE CHOSE DE RÉEL DANS UN SYSTÈME QUI N\'A PAS ÉTÉ FAIT POUR LES ARTISTES',
      manifesto_title: 'Plus qu\'un label.',
      manifesto_p1: 'Vague Vision Sound, c\'est plus qu\'un label, une marque ou une agence.',
      manifesto_p2: 'C\'est un espace pour les artistes qui osent se dépasser, explorer chaque facette de leur identité, et laisser une trace dans la culture.',
      manifesto_p3: 'On donne du pouvoir aux créateurs par l\'innovation et la collaboration. De la production à la scène, on conçoit des expériences immersives qui résonnent en profondeur.',
      what_we_do: 'Ce qu\'on fait',
      releases_title: 'Releases',
      releases_desc: 'La musique qu\'on sort est choisie pour sa profondeur, son concept, son impact durable. Pas pour l\'algorithme. Chaque release est un univers // construit avec intention, sorti avec soin.',
      events_title: 'Events',
      events_desc: 'Des caves underground au Planétarium de Bruxelles, on produit des expériences immersives qui repoussent les limites de ce qu\'une nuit peut être. Son, visuels, espace // traités comme un seul et même medium.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'On accompagne les artistes sur tout le spectre // production, mix & mastering, booking, identité visuelle, communication. On ne sort pas juste de la musique. On construit des carrières.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Services audio professionnels pour les artistes avec une vraie signature sonore. Tous genres. Géré par fromnow depuis son propre setup et via Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'On n\'a pas juste parlé de transparence // on l\'a construite. FairFlow est une infrastructure de contribution et de transparence co-créée par fromnow et le développeur Julien, pensée pour les artistes, les labels et les collectifs culturels. Parce que l\'underground mérite de meilleurs outils.',
      quote_fromnow: '"Créer n\'a jamais été optionnel. C\'était une question de survie. VVS, c\'est la structure que j\'aurais voulu avoir quand j\'ai commencé // construite pour qu\'aucun artiste n\'ait jamais à choisir entre sa vision et le monde."',
      wave_meaning: 'Vague, c\'est le mouvement.\nUne force en constante évolution.\nQui façonne tout sur son passage.\n\nComme le son.\nComme la vision.\nComme ceux qui créent sans peur.',
      wave_poetry: 'Une vague, ça s\'arrête jamais.\nÇa naît de forces invisibles.\nÉnergie. Gravité. Élan.\n\nAucune vague est identique.\nPourtant chacune porte le pouls de son origine.\n\nCertaines s\'écrasent avec intensité.\nD\'autres s\'étendent à l\'infini.\nCertaines naissent du chaos. D\'autres coulent avec précision.\n\nMais toutes existent pour bouger. Transformer. Redéfinir l\'espace.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Certaines expériences sont pas faites pour être regardées.',
      beyond_text2: 'Elles sont faites pour t\'entourer.',
      beyond_text3: 'Sous le dôme, le son devient architecture.\nLa lumière devient mouvement.\nLa présence devient tangible.',
      within_title: 'WITHIN',
      within_desc: 'Show immersif 360°',
      within_venue: 'Planetarium // Observatoire Royal de Belgique',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Billets',
      closing1: 'C\'est pas juste une question de son.',
      closing2: 'C\'est une question d\'impact.',
      closing3: 'C\'est une question de connexion.',
      closing4: 'Entre dans ton flow.',
      closing5: 'Own your wave.',
      moodboard: 'Voir le moodboard sur Pinterest',
      discover: 'Découvrir',
    },
    artists: {
      caption: 'Le Collectif',
      title: 'Artists',
      desc: 'Chaque artiste du collectif VVS est un signal. Une fréquence avec sa propre architecture.',
      open: 'Ouvrir',
      incoming: 'À venir',
      more_soon: 'Plus d\'artistes bientôt',
      rvre_note: 'RVRE est le prochain artiste à signer.',
      open_profile: 'Profil complet →',
      coming_soon: 'Profil complet // bientôt',
      back_to_artists: 'Retour aux Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Un portail s\'ouvre.',
      coming: 'Visiter fairflow.be',
      back: 'Retour à VVS',
      interest: 'Ouvrir fairflow.be',
      project: 'Un projet Vague Vision Sound',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Tous droits réservés.',
    },
    buttons: {
      discover: 'Découvrir',
      listen: 'Écouter',
      view_gallery: 'Voir la galerie',
      back_to_artists: 'Retour aux Artists',
      send: 'Envoyer',
    },
  },

  NL: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Waar geluid ruimte wordt.',
      line1: 'Een flow. Een visie. Een geluid.',
      line2: 'Wij volgen geen stromingen.',
      line3: 'Wij maken golven.',
      enter: 'Enter',
      listen: 'Luister',
    },
    listen: {
      title: 'Begin hier.',
      sub1: 'Diepe grooves.',
      sub2: 'Langzame druk.',
      sub3: 'Gecontroleerde release.',
    },
    portals: {
      title: 'Een universum dat je voelt.',
      desc: '',
      vision: 'Vision', vision_desc: 'De filosofie achter de golven.',
      artists: 'Artists', artists_desc: 'Het collectief. De signalen.',
      events: 'Events', events_desc: 'De volgende herinnering. De ruimte.',
    },
    featured: {
      caption: 'Uitgelichte artiest',
      tagline: 'Oprichter. Geluid als architectuur.',
      bio: 'Tussen hard-groove structuren en dub-sferen creëert fromnow ruimtes die je vasthouden.',
      open: 'Open profiel',
    },
    events_teaser: {
      caption: 'Volgende herinnering.',
      view: 'Bekijk volledig event →',
    },
    contact_section: {
      title: 'Start een gesprek.',
      desc: 'Demo\'s, samenwerkingen, of gewoon een bericht.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Een portaal opent zich.',
      link: 'Bezoek fairflow.be →',
    },
    events: {
      caption: 'Volgende Herinnering',
      subline: '2 zalen.\nGeen headliners.\nÉén visie.',
      date_lbl: 'Datum',
      venue_lbl: 'Locatie',
      ticket_lbl: 'Ticketing',
      view_lineup: 'Bekijk lineup',
      hide_lineup: 'Verberg lineup',
      get_tickets: 'Tickets',
      lineup_title: 'Volledige line-up // 24 Artists',
      last: 'Vorig Event',
      upcoming: 'Komende Events',
      upcoming_empty: 'Nieuwe aankondigingen binnenkort.',
      upcoming_follow: 'Volg @vaguevisionsound voor updates.',
    },
    contact: {
      caption: 'Start een Gesprek',
      title: 'Contact',
      desc: 'Je bent muzikant.\nJe wilt samenwerken.\nJe hebt een project dat een thuis zoekt.',
      name: 'Je naam',
      email: 'Je email',
      subject: 'Waar gaat het over',
      message: 'Je bericht',
      demo_link: 'Privélink (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Privé SoundCloud / Drive / Dropbox URL',
      demo_hint: 'Vermijd links die verlopen.',
      send: 'Verstuur',
      sent_to: 'Verstuurd naar:',
      success_title: 'Bericht ontvangen',
      success_at: 'We nemen contact op via',
      success_close: 'Alles stroomt.',
      type_general: 'Algemeen contact',
      type_partnerships: 'Samenwerkingen',
      type_demo: 'Demo sturen',
      back_to_contact: 'Terug naar contact',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Een flow.',
      intro2: 'Een visie.',
      intro3: 'Een geluid.',
      intro4: 'Wij volgen geen stromingen.',
      intro5: 'Wij maken golven.',
      behind_label: 'Behind the label',
      behind_title: 'IETS ECHTS BOUWEN IN EEN SYSTEEM DAT NIET VOOR ARTIESTEN GEMAAKT IS',
      manifesto_title: 'Meer dan een label.',
      manifesto_p1: 'Vague Vision Sound is meer dan een label, een merk of een bureau.',
      manifesto_p2: 'Het is een ruimte voor artiesten die durven te stijgen boven grenzen, elke facet van hun identiteit te verkennen, en een spoor achter te laten in de cultuur.',
      manifesto_p3: 'Wij geven creators kracht door innovatie en samenwerking. Van productie tot performance, we ontwerpen immersieve ervaringen die dieper resoneren.',
      what_we_do: 'Wat we doen',
      releases_title: 'Releases',
      releases_desc: 'De muziek die we uitbrengen is gekozen voor zijn diepte, zijn concept, zijn blijvende impact. Niet voor het algoritme. Elke release is een wereld // gebouwd met intentie, uitgebracht met zorg.',
      events_title: 'Events',
      events_desc: 'Van underground kelders tot het Brussels Planetarium, we produceren immersieve ervaringen die de grenzen verleggen van wat een nacht kan zijn. Geluid, visuals, ruimte // behandeld als één medium.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'We begeleiden artiesten over het hele spectrum // productie, mix & mastering, booking, visuele identiteit, communicatie. We brengen niet alleen muziek uit. We bouwen carrières.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Professionele audiodiensten voor artiesten met een echte sonische signatuur. Alle genres. Verzorgd door fromnow vanuit zijn eigen setup en via Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'We hebben niet alleen over transparantie gepraat // we hebben het gebouwd. FairFlow is een bijdrage- en transparantie-infrastructuur co-gecreëerd door fromnow en ontwikkelaar Julien, ontworpen voor artiesten, labels en culturele collectieven. Omdat de underground betere tools verdient.',
      quote_fromnow: '"Creëren was nooit optioneel. Het ging om overleven. VVS is de structuur die ik had willen hebben toen ik begon // gebouwd zodat geen enkele artiest ooit moet kiezen tussen zijn visie en de wereld."',
      wave_meaning: 'Vague betekent beweging.\nEen kracht in constante evolutie.\nDie alles op zijn pad vormt.\n\nNet als geluid.\nNet als visie.\nNet als zij die creëren zonder angst.',
      wave_poetry: 'Een golf staat nooit stil.\nHij rijst uit onzichtbare krachten.\nEnergie. Zwaartekracht. Momentum.\n\nGeen golf is ooit hetzelfde.\nToch draagt elke de puls van zijn oorsprong.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Sommige ervaringen zijn niet bedoeld om te bekijken.',
      beyond_text2: 'Ze zijn bedoeld om je te omringen.',
      beyond_text3: 'Onder de koepel wordt geluid architectuur.\nLicht wordt beweging.\nAanwezigheid wordt tastbaar.',
      within_title: 'WITHIN',
      within_desc: '360° Immersive Show',
      within_venue: 'Planetarium // Koninklijke Sterrenwacht van België',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Tickets',
      closing1: 'Dit gaat niet alleen over geluid.',
      closing2: 'Het gaat over impact.',
      closing3: 'Het gaat over verbinding.',
      closing4: 'Stap in jouw flow.',
      closing5: 'Own your wave.',
      moodboard: 'Bekijk moodboard op Pinterest',
      discover: 'Ontdek',
    },
    artists: {
      caption: 'Het Collectief',
      title: 'Artists',
      desc: 'Elke artiest in het VVS collectief is een signaal. Een frequentie met zijn eigen architectuur.',
      open: 'Open',
      incoming: 'Binnenkort',
      more_soon: 'Meer artiesten binnenkort',
      rvre_note: 'RVRE is de volgende artiest die tekent.',
      open_profile: 'Volledig profiel →',
      coming_soon: 'Volledig profiel // binnenkort',
      back_to_artists: 'Terug naar Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Een portaal opent zich.',
      coming: 'Bezoek fairflow.be',
      back: 'Terug naar VVS',
      interest: 'Open fairflow.be',
      project: 'Een Vague Vision Sound project',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Alle rechten voorbehouden.',
    },
    buttons: {
      discover: 'Ontdek',
      listen: 'Luister',
      view_gallery: 'Bekijk galerie',
      back_to_artists: 'Terug naar Artists',
      send: 'Verstuur',
    },
  },

  DE: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Wo Klang zu Raum wird.',
      line1: 'Ein Flow. Eine Vision. Ein Klang.',
      line2: 'Wir folgen keinen Strömungen.',
      line3: 'Wir erschaffen Wellen.',
      enter: 'Enter',
      listen: 'Hören',
    },
    listen: {
      title: 'Hier anfangen.',
      sub1: 'Tiefe Grooves.',
      sub2: 'Langsamer Druck.',
      sub3: 'Kontrollierter Release.',
    },
    portals: {
      title: 'Ein Universum, das du spürst.',
      desc: '',
      vision: 'Vision', vision_desc: 'Die Philosophie hinter den Wellen.',
      artists: 'Artists', artists_desc: 'Das Kollektiv. Die Signale.',
      events: 'Events', events_desc: 'Die nächste Erinnerung. Der Raum.',
    },
    featured: {
      caption: 'Featured Artist',
      tagline: 'Gründer. Klang als Architektur.',
      bio: 'Zwischen Hard-Groove-Strukturen und Dub-Atmosphären erschafft fromnow Räume, die dich halten.',
      open: 'Profil öffnen',
    },
    events_teaser: {
      caption: 'Nächste Erinnerung.',
      view: 'Vollständiges Event ansehen →',
    },
    contact_section: {
      title: 'Ein Gespräch starten.',
      desc: 'Demos, Kooperationen oder einfach eine Nachricht.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Ein Portal öffnet sich.',
      link: 'Besuche fairflow.be →',
    },
    events: {
      caption: 'Nächste Erinnerung',
      subline: '2 Räume.\nKeine Headliner.\nEine Vision.',
      date_lbl: 'Datum',
      venue_lbl: 'Ort',
      ticket_lbl: 'Ticketing',
      view_lineup: 'Lineup anzeigen',
      hide_lineup: 'Lineup ausblenden',
      get_tickets: 'Tickets',
      lineup_title: 'Vollständiges Line-up // 24 Artists',
      last: 'Letztes Event',
      upcoming: 'Kommende Events',
      upcoming_empty: 'Neue Ankündigungen bald.',
      upcoming_follow: 'Folge @vaguevisionsound für Updates.',
    },
    contact: {
      caption: 'Ein Gespräch Starten',
      title: 'Contact',
      desc: 'Du bist Musiker.\nDu willst zusammenarbeiten.\nDu hast ein Projekt, das ein Zuhause sucht.',
      name: 'Dein Name',
      email: 'Deine Email',
      subject: 'Worum geht\'s',
      message: 'Deine Nachricht',
      demo_link: 'Privater Link (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Privater SoundCloud / Drive / Dropbox Link',
      demo_hint: 'Bitte keine ablaufenden Links.',
      send: 'Senden',
      sent_to: 'Gesendet an:',
      success_title: 'Nachricht erhalten',
      success_at: 'Wir melden uns bei',
      success_close: 'Alles fließt.',
      type_general: 'Allgemeiner Kontakt',
      type_partnerships: 'Kooperationen',
      type_demo: 'Demo senden',
      back_to_contact: 'Zurück zum Kontakt',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Ein Flow.',
      intro2: 'Eine Vision.',
      intro3: 'Ein Klang.',
      intro4: 'Wir folgen keinen Strömungen.',
      intro5: 'Wir erschaffen Wellen.',
      behind_label: 'Behind the label',
      behind_title: 'ETWAS ECHTES AUFBAUEN IN EINEM SYSTEM, DAS NICHT FÜR KÜNSTLER GEMACHT WURDE',
      manifesto_title: 'Mehr als ein Label.',
      manifesto_p1: 'Vague Vision Sound ist mehr als ein Label, eine Marke oder eine Agentur.',
      manifesto_p2: 'Es ist ein Raum für Künstler, die es wagen über Grenzen hinauszuwachsen, jede Facette ihrer Identität zu erkunden, und eine Spur in der Kultur zu hinterlassen.',
      manifesto_p3: 'Wir stärken Creators durch Innovation und Zusammenarbeit. Von der Produktion bis zur Performance gestalten wir immersive Erfahrungen, die tiefer resonieren.',
      what_we_do: 'Was wir tun',
      releases_title: 'Releases',
      releases_desc: 'Die Musik, die wir veröffentlichen, ist ausgewählt für ihre Tiefe, ihr Konzept, ihre nachhaltige Wirkung. Nicht für den Algorithmus. Jede Release ist eine Welt // mit Absicht gebaut, mit Sorgfalt veröffentlicht.',
      events_title: 'Events',
      events_desc: 'Von Underground-Kellern bis zum Brüsseler Planetarium produzieren wir immersive Erfahrungen, die die Grenzen dessen verschieben, was eine Nacht sein kann. Sound, Visuals, Raum // als ein einziges Medium behandelt.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'Wir begleiten Künstler über das gesamte Spektrum // Produktion, Mix & Mastering, Booking, visuelle Identität, Kommunikation. Wir veröffentlichen nicht nur Musik. Wir bauen Karrieren.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Professionelle Audiodienste für Künstler mit einer echten klanglichen Signatur. Alle Genres. Betreut von fromnow aus seinem eigenen Setup und über Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'Wir haben nicht nur über Transparenz geredet // wir haben sie gebaut. FairFlow ist eine Beitrags- und Transparenz-Infrastruktur, co-kreiert von fromnow und Entwickler Julien, konzipiert für Künstler, Labels und kulturelle Kollektive. Weil der Underground bessere Tools verdient.',
      quote_fromnow: '"Schaffen war nie optional. Es ging ums Überleben. VVS ist die Struktur, die ich mir gewünscht hätte, als ich anfing // gebaut, damit kein Künstler jemals zwischen seiner Vision und der Welt wählen muss."',
      wave_meaning: 'Vague bedeutet Bewegung.\nEine Kraft in ständiger Evolution.\nDie alles auf ihrem Weg formt.\n\nWie Klang.\nWie Vision.\nWie jene, die ohne Angst erschaffen.',
      wave_poetry: 'Eine Welle steht nie still.\nSie erhebt sich aus unsichtbaren Kräften.\nEnergie. Schwerkraft. Momentum.\n\nKeine Welle ist je gleich.\nDoch jede trägt den Puls ihres Ursprungs.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Manche Erfahrungen sind nicht dazu gedacht, beobachtet zu werden.',
      beyond_text2: 'Sie sind dazu gedacht, dich zu umgeben.',
      beyond_text3: 'Unter der Kuppel wird Klang zur Architektur.\nLicht wird Bewegung.\nPräsenz wird greifbar.',
      within_title: 'WITHIN',
      within_desc: '360° Immersive Show',
      within_venue: 'Planetarium // Königliche Sternwarte Belgiens',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Tickets',
      closing1: 'Es geht nicht nur um Klang.',
      closing2: 'Es geht um Wirkung.',
      closing3: 'Es geht um Verbindung.',
      closing4: 'Tritt in deinen Flow.',
      closing5: 'Own your wave.',
      moodboard: 'Moodboard auf Pinterest ansehen',
      discover: 'Entdecken',
    },
    artists: {
      caption: 'Das Kollektiv',
      title: 'Artists',
      desc: 'Jeder Künstler im VVS-Kollektiv ist ein Signal. Eine Frequenz mit eigener Architektur.',
      open: 'Öffnen',
      incoming: 'Demnächst',
      more_soon: 'Mehr Künstler bald',
      rvre_note: 'RVRE ist der nächste Künstler, der unterschreibt.',
      open_profile: 'Vollständiges Profil →',
      coming_soon: 'Vollständiges Profil // demnächst',
      back_to_artists: 'Zurück zu Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Ein Portal öffnet sich.',
      coming: 'Besuche fairflow.be',
      back: 'Zurück zu VVS',
      interest: 'Öffne fairflow.be',
      project: 'Ein Vague Vision Sound Projekt',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Alle Rechte vorbehalten.',
    },
    buttons: {
      discover: 'Entdecken',
      listen: 'Hören',
      view_gallery: 'Galerie ansehen',
      back_to_artists: 'Zurück zu Artists',
      send: 'Senden',
    },
  },

  ES: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Donde el sonido se convierte en espacio.',
      line1: 'Un flow. Una visión. Un sonido.',
      line2: 'No seguimos la corriente.',
      line3: 'Creamos olas.',
      enter: 'Entrar',
      listen: 'Escuchar',
    },
    listen: {
      title: 'Empieza aquí.',
      sub1: 'Grooves profundos.',
      sub2: 'Presión lenta.',
      sub3: 'Liberación controlada.',
    },
    portals: {
      title: 'Un universo que sientes.',
      desc: '',
      vision: 'Vision', vision_desc: 'La filosofía detrás de las olas.',
      artists: 'Artists', artists_desc: 'El colectivo. Las señales.',
      events: 'Events', events_desc: 'El próximo recuerdo. El espacio.',
    },
    featured: {
      caption: 'Artista destacado',
      tagline: 'Fundador. Sonido como arquitectura.',
      bio: 'Entre estructuras hard-groove y atmósferas dub, fromnow crea espacios que te sostienen.',
      open: 'Ver perfil',
    },
    events_teaser: {
      caption: 'Próximo recuerdo.',
      view: 'Ver evento completo →',
    },
    contact_section: {
      title: 'Abre una conversación.',
      desc: 'Demos, colaboraciones o simplemente un mensaje.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Un portal se abre.',
      link: 'Visitar fairflow.be →',
    },
    events: {
      caption: 'Próximo Recuerdo',
      subline: '2 salas.\nSin cabezas de cartel.\nUna visión.',
      date_lbl: 'Fecha',
      venue_lbl: 'Lugar',
      ticket_lbl: 'Entradas',
      view_lineup: 'Ver lineup',
      hide_lineup: 'Ocultar lineup',
      get_tickets: 'Entradas',
      lineup_title: 'Line-up completo // 24 Artists',
      last: 'Último Event',
      upcoming: 'Próximos Events',
      upcoming_empty: 'Nuevos anuncios pronto.',
      upcoming_follow: 'Sigue @vaguevisionsound para actualizaciones.',
    },
    contact: {
      caption: 'Abre una Conversación',
      title: 'Contact',
      desc: 'Haces música.\nQuieres colaborar.\nTienes un proyecto que busca un hogar.',
      name: 'Tu nombre',
      email: 'Tu email',
      subject: 'De qué se trata',
      message: 'Tu mensaje',
      demo_link: 'Enlace privado (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Enlace privado SoundCloud / Drive / Dropbox',
      demo_hint: 'Evita enlaces que caduquen.',
      send: 'Enviar',
      sent_to: 'Enviado a:',
      success_title: 'Mensaje recibido',
      success_at: 'Te contactamos en',
      success_close: 'Todo fluye.',
      type_general: 'Contacto general',
      type_partnerships: 'Colaboraciones',
      type_demo: 'Enviar demo',
      back_to_contact: 'Volver al contacto',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Un flow.',
      intro2: 'Una visión.',
      intro3: 'Un sonido.',
      intro4: 'No seguimos la corriente.',
      intro5: 'Creamos olas.',
      behind_label: 'Behind the label',
      behind_title: 'CONSTRUYENDO ALGO REAL EN UN SISTEMA QUE NO FUE HECHO PARA LOS ARTISTAS',
      manifesto_title: 'Más que un label.',
      manifesto_p1: 'Vague Vision Sound es más que un label, una marca o una agencia.',
      manifesto_p2: 'Es un espacio para artistas que se atreven a superar límites, explorar cada faceta de su identidad, y dejar huella en la cultura.',
      manifesto_p3: 'Empoderamos a los creadores a través de la innovación y la colaboración. De la producción al escenario, diseñamos experiencias inmersivas que resuenan en profundidad.',
      what_we_do: 'Lo que hacemos',
      releases_title: 'Releases',
      releases_desc: 'La música que lanzamos se elige por su profundidad, su concepto, su impacto duradero. No para el algoritmo. Cada release es un universo // construido con intención, lanzado con cuidado.',
      events_title: 'Events',
      events_desc: 'De sótanos underground al Planetario de Bruselas, producimos experiencias inmersivas que empujan los límites de lo que una noche puede ser. Sonido, visuales, espacio // tratados como un solo medio.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'Acompañamos a los artistas en todo el espectro // producción, mezcla & mastering, booking, identidad visual, comunicación. No solo lanzamos música. Construimos carreras.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Servicios de audio profesionales para artistas con una firma sonora real. Todos los géneros. Gestionado por fromnow desde su propio setup y vía Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'No solo hablamos de transparencia // la construimos. FairFlow es una infraestructura de contribución y transparencia co-creada por fromnow y el desarrollador Julien, diseñada para artistas, labels y colectivos culturales. Porque el underground merece mejores herramientas.',
      quote_fromnow: '"Crear nunca fue opcional. Era supervivencia. VVS es la estructura que ojalá hubiera existido cuando empecé // construida para que ningún artista tenga que elegir entre su visión y el mundo."',
      wave_meaning: 'Vague significa movimiento.\nUna fuerza en constante evolución.\nDando forma a todo en su camino.\n\nComo el sonido.\nComo la visión.\nComo quienes crean sin miedo.',
      wave_poetry: 'Una ola nunca está quieta.\nSurge de fuerzas invisibles.\nEnergía. Gravedad. Momento.\n\nNinguna ola es igual.\nPero cada una lleva el pulso de su origen.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Algunas experiencias no están hechas para ser observadas.',
      beyond_text2: 'Están hechas para rodearte.',
      beyond_text3: 'Bajo la cúpula, el sonido se convierte en arquitectura.\nLa luz se convierte en movimiento.\nLa presencia se vuelve tangible.',
      within_title: 'WITHIN',
      within_desc: 'Show inmersivo 360°',
      within_venue: 'Planetarium // Observatorio Real de Bélgica',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Entradas',
      closing1: 'No se trata solo de sonido.',
      closing2: 'Se trata de impacto.',
      closing3: 'Se trata de conexión.',
      closing4: 'Entra en tu flow.',
      closing5: 'Own your wave.',
      moodboard: 'Ver moodboard en Pinterest',
      discover: 'Descubrir',
    },
    artists: {
      caption: 'El Colectivo',
      title: 'Artists',
      desc: 'Cada artista del colectivo VVS es una señal. Una frecuencia con su propia arquitectura.',
      open: 'Abrir',
      incoming: 'Próximamente',
      more_soon: 'Más artistas pronto',
      rvre_note: 'RVRE es el próximo artista en firmar.',
      open_profile: 'Perfil completo →',
      coming_soon: 'Perfil completo // pronto',
      back_to_artists: 'Volver a Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Un portal se abre.',
      coming: 'Visitar fairflow.be',
      back: 'Volver a VVS',
      interest: 'Abrir fairflow.be',
      project: 'Un proyecto Vague Vision Sound',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Todos los derechos reservados.',
    },
    buttons: {
      discover: 'Descubrir',
      listen: 'Escuchar',
      view_gallery: 'Ver galería',
      back_to_artists: 'Volver a Artists',
      send: 'Enviar',
    },
  },

  PT: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Onde o som se torna espaço.',
      line1: 'Um flow. Uma visão. Um som.',
      line2: 'Não seguimos correntes.',
      line3: 'Criamos ondas.',
      enter: 'Entrar',
      listen: 'Ouvir',
    },
    listen: {
      title: 'Começa aqui.',
      sub1: 'Grooves profundos.',
      sub2: 'Pressão lenta.',
      sub3: 'Libertação controlada.',
    },
    portals: {
      title: 'Um universo que sentes.',
      desc: '',
      vision: 'Vision', vision_desc: 'A filosofia por trás das ondas.',
      artists: 'Artists', artists_desc: 'O coletivo. Os sinais.',
      events: 'Events', events_desc: 'A próxima memória. O espaço.',
    },
    featured: {
      caption: 'Artista em destaque',
      tagline: 'Fundador. Som como arquitetura.',
      bio: 'Entre estruturas hard-groove e atmosferas dub, fromnow cria espaços que te seguram.',
      open: 'Ver perfil',
    },
    events_teaser: {
      caption: 'Próxima memória.',
      view: 'Ver evento completo →',
    },
    contact_section: {
      title: 'Abre uma conversa.',
      desc: 'Demos, parcerias ou simplesmente uma mensagem.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Um portal está a abrir.',
      link: 'Visitar fairflow.be →',
    },
    events: {
      caption: 'Próxima Memória',
      subline: '2 salas.\nSem cabeças de cartaz.\nUma visão.',
      date_lbl: 'Data',
      venue_lbl: 'Local',
      ticket_lbl: 'Bilhetes',
      view_lineup: 'Ver lineup',
      hide_lineup: 'Esconder lineup',
      get_tickets: 'Bilhetes',
      lineup_title: 'Line-up completo // 24 Artists',
      last: 'Último Event',
      upcoming: 'Próximos Events',
      upcoming_empty: 'Novos anúncios em breve.',
      upcoming_follow: 'Segue @vaguevisionsound para atualizações.',
    },
    contact: {
      caption: 'Abre uma Conversa',
      title: 'Contact',
      desc: 'Fazes música.\nQueres colaborar.\nTens um projeto que procura um lar.',
      name: 'O teu nome',
      email: 'O teu email',
      subject: 'Sobre o quê',
      message: 'A tua mensagem',
      demo_link: 'Link privado (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Link privado SoundCloud / Drive / Dropbox',
      demo_hint: 'Evita links que expirem.',
      send: 'Enviar',
      sent_to: 'Enviado para:',
      success_title: 'Mensagem recebida',
      success_at: 'Entramos em contacto em',
      success_close: 'Tudo flui.',
      type_general: 'Contacto geral',
      type_partnerships: 'Parcerias',
      type_demo: 'Enviar demo',
      back_to_contact: 'Voltar ao contacto',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Um flow.',
      intro2: 'Uma visão.',
      intro3: 'Um som.',
      intro4: 'Não seguimos correntes.',
      intro5: 'Criamos ondas.',
      behind_label: 'Behind the label',
      behind_title: 'CONSTRUINDO ALGO REAL NUM SISTEMA QUE NÃO FOI FEITO PARA OS ARTISTAS',
      manifesto_title: 'Mais do que um label.',
      manifesto_p1: 'Vague Vision Sound é mais do que um label, uma marca ou uma agência.',
      manifesto_p2: 'É um espaço para artistas que ousam ultrapassar limites, explorar cada faceta da sua identidade, e deixar marca na cultura.',
      manifesto_p3: 'Capacitamos criadores através da inovação e colaboração. Da produção ao palco, desenhamos experiências imersivas que ressoam em profundidade.',
      what_we_do: 'O que fazemos',
      releases_title: 'Releases',
      releases_desc: 'A música que lançamos é escolhida pela sua profundidade, conceito e impacto duradouro. Não pelo algoritmo. Cada release é um universo // construído com intenção, lançado com cuidado.',
      events_title: 'Events',
      events_desc: 'De caves underground ao Planetário de Bruxelas, produzimos experiências imersivas que empurram os limites do que uma noite pode ser. Som, visuais, espaço // tratados como um único meio.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'Acompanhamos artistas em todo o espectro // produção, mix & mastering, booking, identidade visual, comunicação. Não lançamos apenas música. Construímos carreiras.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Serviços de áudio profissionais para artistas com uma assinatura sonora real. Todos os géneros. Gerido pelo fromnow a partir do seu próprio setup e via Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'Não ficámos só a falar de transparência // construímo-la. FairFlow é uma infraestrutura de contribuição e transparência co-criada pelo fromnow e o developer Julien, desenhada para artistas, labels e coletivos culturais. Porque o underground merece melhores ferramentas.',
      quote_fromnow: '"Criar nunca foi opcional. Era sobrevivência. A VVS é a estrutura que eu gostava de ter tido quando comecei // construída para que nenhum artista tenha de escolher entre a sua visão e o mundo."',
      wave_meaning: 'Vague significa movimento.\nUma força em constante evolução.\nMoldando tudo no seu caminho.\n\nComo o som.\nComo a visão.\nComo aqueles que criam sem medo.',
      wave_poetry: 'Uma onda nunca está parada.\nNasce de forças invisíveis.\nEnergia. Gravidade. Momento.\n\nNenhuma onda é igual.\nMas cada uma carrega o pulso da sua origem.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Algumas experiências não são feitas para ser observadas.',
      beyond_text2: 'São feitas para te envolver.',
      beyond_text3: 'Sob a cúpula, o som torna-se arquitetura.\nA luz torna-se movimento.\nA presença torna-se tangível.',
      within_title: 'WITHIN',
      within_desc: 'Show imersivo 360°',
      within_venue: 'Planetarium // Observatório Real da Bélgica',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Bilhetes',
      closing1: 'Não é só sobre som.',
      closing2: 'É sobre impacto.',
      closing3: 'É sobre conexão.',
      closing4: 'Entra no teu flow.',
      closing5: 'Own your wave.',
      moodboard: 'Ver moodboard no Pinterest',
      discover: 'Descobrir',
    },
    artists: {
      caption: 'O Coletivo',
      title: 'Artists',
      desc: 'Cada artista do coletivo VVS é um sinal. Uma frequência com a sua própria arquitetura.',
      open: 'Abrir',
      incoming: 'Em breve',
      more_soon: 'Mais artistas em breve',
      rvre_note: 'RVRE é o próximo artista a assinar.',
      open_profile: 'Perfil completo →',
      coming_soon: 'Perfil completo // em breve',
      back_to_artists: 'Voltar a Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Um portal está a abrir.',
      coming: 'Visitar fairflow.be',
      back: 'Voltar a VVS',
      interest: 'Abrir fairflow.be',
      project: 'Um projeto Vague Vision Sound',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Todos os direitos reservados.',
    },
    buttons: {
      discover: 'Descobrir',
      listen: 'Ouvir',
      view_gallery: 'Ver galeria',
      back_to_artists: 'Voltar a Artists',
      send: 'Enviar',
    },
  },

  IT: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: 'Dove il suono diventa spazio.',
      line1: 'Un flow. Una visione. Un suono.',
      line2: 'Non seguiamo le correnti.',
      line3: 'Creiamo onde.',
      enter: 'Entra',
      listen: 'Ascolta',
    },
    listen: {
      title: 'Inizia qui.',
      sub1: 'Groove profondi.',
      sub2: 'Pressione lenta.',
      sub3: 'Rilascio controllato.',
    },
    portals: {
      title: 'Un universo che senti.',
      desc: '',
      vision: 'Vision', vision_desc: 'La filosofia dietro le onde.',
      artists: 'Artists', artists_desc: 'Il collettivo. I segnali.',
      events: 'Events', events_desc: 'Il prossimo ricordo. Lo spazio.',
    },
    featured: {
      caption: 'Artista in evidenza',
      tagline: 'Fondatore. Suono come architettura.',
      bio: 'Tra strutture hard-groove e atmosfere dub, fromnow crea spazi che ti tengono.',
      open: 'Apri profilo',
    },
    events_teaser: {
      caption: 'Prossimo ricordo.',
      view: 'Vedi evento completo →',
    },
    contact_section: {
      title: 'Apri una conversazione.',
      desc: 'Demo, collaborazioni o semplicemente un messaggio.',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'Un portale si sta aprendo.',
      link: 'Visita fairflow.be →',
    },
    events: {
      caption: 'Prossimo Ricordo',
      subline: '2 sale.\nNessun headliner.\nUna visione.',
      date_lbl: 'Data',
      venue_lbl: 'Luogo',
      ticket_lbl: 'Biglietti',
      view_lineup: 'Vedi lineup',
      hide_lineup: 'Nascondi lineup',
      get_tickets: 'Biglietti',
      lineup_title: 'Line-up completo // 24 Artists',
      last: 'Ultimo Event',
      upcoming: 'Prossimi Events',
      upcoming_empty: 'Nuovi annunci presto.',
      upcoming_follow: 'Segui @vaguevisionsound per aggiornamenti.',
    },
    contact: {
      caption: 'Apri una Conversazione',
      title: 'Contact',
      desc: 'Fai musica.\nVuoi collaborare.\nHai un progetto che cerca casa.',
      name: 'Il tuo nome',
      email: 'La tua email',
      subject: 'Di cosa si tratta',
      message: 'Il tuo messaggio',
      demo_link: 'Link privato (SoundCloud, Drive, Dropbox)',
      demo_ph: 'Link privato SoundCloud / Drive / Dropbox',
      demo_hint: 'Evita link in scadenza.',
      send: 'Invia',
      sent_to: 'Inviato a:',
      success_title: 'Messaggio ricevuto',
      success_at: 'Ti contattiamo a',
      success_close: 'Tutto scorre.',
      type_general: 'Contatto generale',
      type_partnerships: 'Collaborazioni',
      type_demo: 'Invia demo',
      back_to_contact: 'Torna al contatto',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'Un flow.',
      intro2: 'Una visione.',
      intro3: 'Un suono.',
      intro4: 'Non seguiamo le correnti.',
      intro5: 'Creiamo onde.',
      behind_label: 'Behind the label',
      behind_title: 'COSTRUIRE QUALCOSA DI REALE IN UN SISTEMA CHE NON È STATO FATTO PER GLI ARTISTI',
      manifesto_title: 'Più di un label.',
      manifesto_p1: 'Vague Vision Sound è più di un label, un brand o un\'agenzia.',
      manifesto_p2: 'È uno spazio per artisti che osano superare i limiti, esplorare ogni sfaccettatura della loro identità, e lasciare un segno nella cultura.',
      manifesto_p3: 'Diamo potere ai creatori attraverso l\'innovazione e la collaborazione. Dalla produzione al palco, progettiamo esperienze immersive che risuonano in profondità.',
      what_we_do: 'Cosa facciamo',
      releases_title: 'Releases',
      releases_desc: 'La musica che pubblichiamo è scelta per la sua profondità, il suo concept, il suo impatto duraturo. Non per l\'algoritmo. Ogni release è un universo // costruito con intenzione, pubblicato con cura.',
      events_title: 'Events',
      events_desc: 'Dai sotterranei underground al Planetario di Bruxelles, produciamo esperienze immersive che spingono i limiti di ciò che una notte può essere. Suono, visual, spazio // trattati come un unico mezzo.',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'Accompagniamo gli artisti su tutto lo spettro // produzione, mix & mastering, booking, identità visiva, comunicazione. Non pubblichiamo solo musica. Costruiamo carriere.',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: 'Servizi audio professionali per artisti con una vera firma sonora. Tutti i generi. Gestito da fromnow dal suo setup e tramite Temple Studios.',
      fairflow_title: 'FairFlow',
      fairflow_desc: 'Non abbiamo solo parlato di trasparenza // l\'abbiamo costruita. FairFlow è un\'infrastruttura di contribuzione e trasparenza co-creata da fromnow e lo sviluppatore Julien, pensata per artisti, label e collettivi culturali. Perché l\'underground merita strumenti migliori.',
      quote_fromnow: '"Creare non è mai stato opzionale. Era sopravvivenza. VVS è la struttura che avrei voluto avere quando ho iniziato // costruita perché nessun artista debba mai scegliere tra la sua visione e il mondo."',
      wave_meaning: 'Vague significa movimento.\nUna forza in costante evoluzione.\nChe modella tutto sul suo percorso.\n\nCome il suono.\nCome la visione.\nCome chi crea senza paura.',
      wave_poetry: 'Un\'onda non sta mai ferma.\nNasce da forze invisibili.\nEnergia. Gravità. Momento.\n\nNessun\'onda è uguale.\nMa ognuna porta il battito della sua origine.',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'Alcune esperienze non sono fatte per essere osservate.',
      beyond_text2: 'Sono fatte per circondarti.',
      beyond_text3: 'Sotto la cupola, il suono diventa architettura.\nLa luce diventa movimento.\nLa presenza diventa tangibile.',
      within_title: 'WITHIN',
      within_desc: 'Show immersivo 360°',
      within_venue: 'Planetarium // Osservatorio Reale del Belgio',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'Biglietti',
      closing1: 'Non si tratta solo di suono.',
      closing2: 'Si tratta di impatto.',
      closing3: 'Si tratta di connessione.',
      closing4: 'Entra nel tuo flow.',
      closing5: 'Own your wave.',
      moodboard: 'Vedi moodboard su Pinterest',
      discover: 'Scopri',
    },
    artists: {
      caption: 'Il Collettivo',
      title: 'Artists',
      desc: 'Ogni artista del collettivo VVS è un segnale. Una frequenza con la propria architettura.',
      open: 'Apri',
      incoming: 'In arrivo',
      more_soon: 'Altri artisti presto',
      rvre_note: 'RVRE è il prossimo artista a firmare.',
      open_profile: 'Profilo completo →',
      coming_soon: 'Profilo completo // presto',
      back_to_artists: 'Torna a Artists',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'Un portale si sta aprendo.',
      coming: 'Visita fairflow.be',
      back: 'Torna a VVS',
      interest: 'Apri fairflow.be',
      project: 'Un progetto Vague Vision Sound',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. Tutti i diritti riservati.',
    },
    buttons: {
      discover: 'Scopri',
      listen: 'Ascolta',
      view_gallery: 'Vedi galleria',
      back_to_artists: 'Torna a Artists',
      send: 'Invia',
    },
  },

  JA: {
    nav: {
      events: 'Events',
      vision: 'Vision',
      artists: 'Artists',
      releases: 'Releases',
      partners: 'Partners',
      contact: 'Contact',
      music: 'Music',
      fairflow: 'Fairflow App',
    },
    hero: {
      tagline: '音が空間になる場所。',
      line1: 'フロー。ビジョン。サウンド。',
      line2: '流れに従わない。',
      line3: '波を作る。',
      enter: '入る',
      listen: '聴く',
    },
    listen: {
      title: 'ここから始める。',
      sub1: '深いグルーヴ。',
      sub2: 'ゆっくりとした圧力。',
      sub3: 'コントロールされたリリース。',
    },
    portals: {
      title: '感じる宇宙。',
      desc: '',
      vision: 'Vision', vision_desc: '波の裏にある哲学。',
      artists: 'Artists', artists_desc: 'コレクティブ。信号。',
      events: 'Events', events_desc: '次の記憶。空間。',
    },
    featured: {
      caption: '注目アーティスト',
      tagline: '創設者。建築としてのサウンド。',
      bio: 'ハードグルーヴの構造とダブのアトモスフィアの間で、fromnowはあなたを包む空間を創る。',
      open: 'プロフィールを見る',
    },
    events_teaser: {
      caption: '次の記憶。',
      view: 'イベント詳細を見る →',
    },
    contact_section: {
      title: '会話を始める。',
      desc: 'デモ、パートナーシップ、またはメッセージ。',
      btn: 'Contact',
    },
    fairflow_section: {
      label: 'Fairflow',
      desc: 'ポータルが開く。',
      link: 'fairflow.be を見る →',
    },
    events: {
      caption: '次の記憶',
      subline: '2つのルーム。\nヘッドライナーなし。\n一つのビジョン。',
      date_lbl: '日付',
      venue_lbl: '会場',
      ticket_lbl: 'チケット',
      view_lineup: 'ラインナップを見る',
      hide_lineup: 'ラインナップを隠す',
      get_tickets: 'チケット',
      lineup_title: 'フルラインナップ // 24 Artists',
      last: '前回のEvent',
      upcoming: '今後のEvents',
      upcoming_empty: '新しい発表が近日中に。',
      upcoming_follow: '@vaguevisionsound をフォローして更新を受け取る。',
    },
    contact: {
      caption: '会話を始める',
      title: 'Contact',
      desc: '音楽を作っている。\n一緒に何かをしたい。\n居場所を探しているプロジェクトがある。',
      name: '名前',
      email: 'メール',
      subject: '件名',
      message: 'メッセージ',
      demo_link: 'プライベートリンク (SoundCloud, Drive, Dropbox)',
      demo_ph: 'SoundCloud / Drive / Dropbox のプライベートリンク',
      demo_hint: '期限切れのリンクは避けてください。',
      send: '送信',
      sent_to: '送信先:',
      success_title: 'メッセージを受け取りました',
      success_at: '連絡先:',
      success_close: 'すべてが流れる。',
      type_general: '一般的なお問い合わせ',
      type_partnerships: 'パートナーシップ',
      type_demo: 'デモを送る',
      back_to_contact: '連絡先に戻る',
    },
    vision: {
      own_wave: 'OWN YOUR WAVE',
      intro1: 'フロー。',
      intro2: 'ビジョン。',
      intro3: 'サウンド。',
      intro4: '流れに従わない。',
      intro5: '波を作る。',
      behind_label: 'Behind the label',
      behind_title: 'アーティストのために作られていないシステムの中で、本物を築く',
      manifesto_title: 'ただのレーベルではない。',
      manifesto_p1: 'Vague Vision Soundは、レーベル、ブランド、エージェンシー以上のもの。',
      manifesto_p2: '限界を超え、アイデンティティのあらゆる側面を探求し、文化に足跡を残す勇気を持つアーティストのための空間。',
      manifesto_p3: 'イノベーションとコラボレーションを通じてクリエイターを支援する。プロダクションからパフォーマンスまで、深く響くイマーシブな体験をデザインする。',
      what_we_do: '私たちがやること',
      releases_title: 'Releases',
      releases_desc: 'リリースする音楽は、その深さ、コンセプト、持続的なインパクトで選ばれる。アルゴリズムのためではない。各リリースは宇宙 // 意図を持って構築され、丁寧にリリースされる。',
      events_title: 'Events',
      events_desc: 'アンダーグラウンドの地下室からブリュッセルのプラネタリウムまで、一夜の限界を押し広げるイマーシブな体験をプロデュース。サウンド、ビジュアル、空間 // 一つのメディアとして扱う。',
      artist_dev_title: 'Artist Development',
      artist_dev_desc: 'アーティストを全領域でサポート // プロダクション、ミックス＆マスタリング、ブッキング、ビジュアルアイデンティティ、コミュニケーション。音楽をリリースするだけではない。キャリアを構築する。',
      mixing_title: 'Mixing & Mastering',
      mixing_desc: '本物のソニックシグネチャーを持つアーティストのためのプロフェッショナルオーディオサービス。全ジャンル。fromnowが自身のセットアップとTemple Studios経由で担当。',
      fairflow_title: 'FairFlow',
      fairflow_desc: '透明性について語るだけでなく、それを築いた。FairFlowは、fromnowとデベロッパーJulienが共同で作った貢献と透明性のインフラ。アーティスト、レーベル、文化コレクティブのために設計。アンダーグラウンドはより良いツールを受ける価値があるから。',
      quote_fromnow: '「創ることは選択肢ではなかった。それは生存だった。VVSは、自分が始めた頃に存在してほしかった仕組み // アーティストがビジョンと現実の間で選択を迫られることのないために作られた。」',
      wave_meaning: 'Vagueは動きを意味する。\n常に進化する力。\n道にあるすべてを形作る。\n\nサウンドのように。\nビジョンのように。\n恐れずに創る者たちのように。',
      wave_poetry: '波は決して止まらない。\n見えない力から生まれる。\nエネルギー。重力。モメンタム。\n\n同じ波は二つとない。\nしかし、それぞれが起源の鼓動を運ぶ。',
      beyond_title: 'Beyond the stage.',
      beyond_text1: 'ある体験は観るためのものではない。',
      beyond_text2: 'あなたを包むためのもの。',
      beyond_text3: 'ドームの下で、サウンドは建築になる。\n光は動きになる。\n存在は触れられるものになる。',
      within_title: 'WITHIN',
      within_desc: '360° イマーシブショー',
      within_venue: 'Planetarium // ベルギー王立天文台',
      within_date: '26.02.2026',
      within_city: 'Brussels',
      within_btn: 'チケット',
      closing1: 'これはサウンドだけの話ではない。',
      closing2: 'インパクトの話。',
      closing3: '繋がりの話。',
      closing4: '自分のフローに入る。',
      closing5: 'Own your wave.',
      moodboard: 'Pinterestでムードボードを見る',
      discover: '発見する',
    },
    artists: {
      caption: 'コレクティブ',
      title: 'Artists',
      desc: 'VVSコレクティブの各アーティストは信号。独自の建築を持つ周波数。',
      open: '開く',
      incoming: '近日公開',
      more_soon: 'より多くのアーティストが近日中に',
      rvre_note: 'RVREは次に署名するアーティスト。',
      open_profile: 'フルプロフィール →',
      coming_soon: 'フルプロフィール // 近日公開',
      back_to_artists: 'Artistsに戻る',
    },
    fairflow: {
      label: 'Fairflow',
      title1: 'Fairflow',
      title2: '',
      body: 'ポータルが開く。',
      coming: 'fairflow.beを見る',
      back: 'VVSに戻る',
      interest: 'fairflow.beを開く',
      project: 'Vague Vision Soundプロジェクト',
    },
    footer: {
      tagline: 'Sound shaped in waves.',
      rights: '© 2025 Vague Vision Sound. All rights reserved.',
    },
    buttons: {
      discover: '発見する',
      listen: '聴く',
      view_gallery: 'ギャラリーを見る',
      back_to_artists: 'Artistsに戻る',
      send: '送信',
    },
  },
};

export default T;
